import { motion } from 'framer-motion';
import React, { useState } from 'react';

// import SvgYoutubeMinimalAfter from '../../Icon/YoutubeMinimalAfter';
import SvgYoutubeMinimalAfter from '../../Icon/YoutubeMinimalAfter';

interface LiveMinimalAfterProps {
  isShowTopBanner?: boolean;
  onClose?: () => void;
  liveStreamVideoUrl: string;
}

export default function LiveMinimalAfter({
  isShowTopBanner = false,
  onClose,
  liveStreamVideoUrl,
}: LiveMinimalAfterProps) {
  const [isHidden, setIsHidden] = useState(false);
  const topPosition = isShowTopBanner ? 'top-[100px]' : 'top-[60px]';

  const handleClose = () => {
    setIsHidden(true);
    if (onClose) {
      onClose();
    }
  };

  if (isHidden) {
    return null;
  }

  const handleClickWatch = () => {
    window.open(`${liveStreamVideoUrl}`, '_blank');
  };

  return (
    <div
      className={`bg-white border border-gray-200 rounded-[16px] shadow-lg h-auto py-4 overflow-hidden fixed ${topPosition} z-[100] mx-auto max-w-[720px] w-[97%] left-[50%] translate-x-[-50%] `}
    >
      <div className="flex items-center justify-between h-full px-4 gap-3 flex-row sm280:flex-col">
        <div className="flex items-center gap-3">
          {/* Minimalist icon */}
          <div className="relative">
            <div className="flex items-center justify-center rounded-lg size-[40px] bg-gray-100">
              <SvgYoutubeMinimalAfter />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <motion.div
                className="bg-[#FB2C36] px-2 py-0.5 rounded text-white text-[10px] font-semibold"
                animate={{
                  opacity: [1, 0.8, 1],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                }}
              >
                LIVE
              </motion.div>
              <span className="text-[#FB2C36] font-semibold text-[16px]">라이브 방송 중</span>
            </div>
            <p className="text-[#737373] font-medium text-[14px] sm280:text-[12px]">직트럭 라이브를 시청하세요</p>
          </div>
        </div>

        {/* Clean CTA Button */}
        {/* <button className="px-5 py-2 rounded-lg bg-[#FB2C36] text-white text-[12px] font-semibold whitespace-nowrap">
          시청하기
        </button> */}
        <motion.button
          className="sm280:w-full px-4 py-2 rounded-[10px] bg-[#FB2C36] text-white text-[12px] font-semibold whitespace-nowrap"
          animate={{
            boxShadow: ['0 0 0 0 rgba(239, 68, 68, 0.4)', '0 0 0 10px rgba(239, 68, 68, 0)'],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
          }}
          onClick={handleClickWatch}
        >
          시청하기
        </motion.button>
      </div>
    </div>
  );
}
